import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React, { forwardRef, useState } from 'react';
import { compact } from 'lodash-es';
import { BottomSheetContentLayout } from '../BottomSheet';
import { useOverlayContext } from '../OverlayContext';
import { Typography } from '../Typography';
import { BaseTextField } from './BaseTextField/BaseTextField';
import { MobileTextFieldTID } from './BaseTextField/BaseTextField.utils';
import { MobileSummaryCard } from './MobileSummaryCard';
import styles from './MobileTextField.module.scss';
const TextFieldInBottomSheet = /*#__PURE__*/ forwardRef(function TextFieldInBottomSheet(props, ref) {
    const { validateInBottomSheet, width: _width, minWidth: _minWidth } = props, rest = _object_without_properties(props, [
        "validateInBottomSheet",
        "width",
        "minWidth"
    ]);
    const { hideBottomSheet } = useOverlayContext();
    const [tempValue, setTempValue] = useState(props.value);
    const validationResult = validateInBottomSheet === null || validateInBottomSheet === void 0 ? void 0 : validateInBottomSheet(tempValue);
    const error = validationResult ? validationResult.error : props.error;
    const helperText = validationResult ? validationResult.helperText : props.helperText;
    function handleSave() {
        if (tempValue !== props.value && props.onChange) {
            props.onChange({
                target: {
                    value: tempValue
                }
            });
        }
        hideBottomSheet();
    }
    return /*#__PURE__*/ _jsx(BottomSheetContentLayout, {
        contentClassName: styles.bottomSheetContent,
        footer: {
            primaryAction: {
                text: 'Save',
                onClick: ()=>handleSave()
            }
        },
        children: /*#__PURE__*/ _jsx(BaseTextField, _object_spread_props(_object_spread({}, rest), {
            collapseHelperText: true,
            value: tempValue,
            error: error,
            helperText: helperText,
            onChange: (e)=>setTempValue(e.target.value),
            onKeyDown: ()=>{},
            ref: ref
        }))
    });
});
export const MobileTextField = /*#__PURE__*/ forwardRef(function MobileTextField(props, ref) {
    var _ref;
    const { testId, error, label, value, helperText, disabled, mobile } = props;
    const { pushBottomSheetPage } = useOverlayContext();
    return /*#__PURE__*/ _jsx(MobileSummaryCard, {
        testId: testId,
        items: [
            {
                title: label,
                titleTestId: MobileTextFieldTID.Label(testId),
                body: /*#__PURE__*/ _jsxs(_Fragment, {
                    children: [
                        /*#__PURE__*/ _jsx(Typography, {
                            ellipsis: true,
                            testId: MobileTextFieldTID.Value(testId),
                            skin: error ? 'error' : 'standard',
                            children: (_ref = mobile === null || mobile === void 0 ? void 0 : mobile.displayValue) !== null && _ref !== void 0 ? _ref : value
                        }),
                        helperText && /*#__PURE__*/ _jsx(Typography, {
                            testId: MobileTextFieldTID.HelperText(testId),
                            skin: error ? 'error' : 'secondary',
                            children: helperText
                        })
                    ]
                }),
                actions: compact([
                    !disabled && {
                        type: 'edit',
                        testId: MobileTextFieldTID.EditButton(testId),
                        onClick: ()=>{
                            pushBottomSheetPage({
                                content: /*#__PURE__*/ _jsx(TextFieldInBottomSheet, _object_spread_props(_object_spread({}, props), {
                                    ref: ref
                                }))
                            });
                        }
                    }
                ])
            }
        ]
    });
});
